module.exports = __webpack_public_path__ + "2f3c6cc0020d077434e8a1b546f8277a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2000_11_teaser_image.jpg
// module id = 543
// module chunks = 0